import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { AssistanceTicketInterface } from '@app/interface/assistance-ticket';

@Injectable({
  providedIn: 'root',
})
export class AssistanceTicketApiService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient, // private cookieService: CookieService
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  public getAllTickets<T = AssistanceTicketInterface>(
    organization_id: number | null,
    params: httpQueryParams = {},
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/ticket/`;
    return this.getRecursivePage<T>(path, params);
  }

  public getSpecificTickets<T = AssistanceTicketInterface>(
    organization_id: number | null,
    id: number,
    params: httpQueryParams = {},
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/ticket/${id}/`;
    return this.getRecursivePage<T>(path, params);
  }

  public createTicket(
    organization_id: number | null,
    ticketData: Partial<AssistanceTicketInterface>,
  ): Observable<AssistanceTicketInterface> {
    if (!ticketData.organization_id) {
      ticketData.organization_id = 1; // Default to company with ID 1
    } else {
      organization_id = ticketData.organization_id;
    }
    const path = `api/${organization_id}/ticket/`;

    return this.post<AssistanceTicketInterface>(path, {}, ticketData);
  }

  public updateTicket(
    organization_id: number | null,
    id: number,
    data: Partial<AssistanceTicketInterface>,
  ): Observable<AssistanceTicketInterface> {
    // console.log(data);
    return this.partialUpdate<AssistanceTicketInterface>(
      `api/${organization_id}/ticket/${id}/`,
      {}, //{ withCredentials: true },
      data,
    );
  }
}
